import config from '../../config'
import { buildGetQuery } from '../../util'
import { QueryObserverOptions } from '@tanstack/react-query'
import { ITrainingType } from '../../interfaces'

type QueryObject = { trainingGroupId?: number }

const useTrainingGroupRequirementsQueryBase = buildGetQuery<
  undefined,
  QueryObject | undefined,
  ITrainingType[] | undefined
>({
  getRequest: (_params, queryObject) => ({
    method: 'get',
    url: `${config.baseUrl}/TrainingGroups/${queryObject?.trainingGroupId ?? ''}/template`,
    skip: !queryObject || !queryObject.trainingGroupId, // Skip if trainingGroupId is not provided

  }),
  getQueryKey: (_params, queryObject) => [
    'group-training-requirements',
    queryObject?.trainingGroupId,
  ],
})

const useTrainingGroupRequirementsQuery = (
  queryObject?: QueryObject,
  options?: QueryObserverOptions<ITrainingType[] | undefined, Error>,
) => useTrainingGroupRequirementsQueryBase(undefined, queryObject, options)

export default useTrainingGroupRequirementsQuery